import React from 'react';

import { observer } from 'mobx-react-lite'
import clsx from 'clsx';

const LeftSideCell = observer(function LeftSideCell(props) {

    const { rowIndex, changeSelection, screen, className, cell_key, style } = props;
    const isSelected = screen.is_selected(screen.get_record_by_index(rowIndex).id)
    const cls = isSelected ? clsx(className, "bg-light-selected"):className

    return (
        <div className={cls}  >
            {/* <LeftSideCell screen={screen} rowIndex={rowIndex} changeSelection={changeSelection}/> */}
            <input
                checked={isSelected}
                type="checkbox"
                size="small"
                color="primary"
                style={{ padding: 0 }}
                onChange={(e) => { changeSelection(e, rowIndex) }}


            />
        </div>

    )


});

export default LeftSideCell;